import React from 'react'

const SnippetHTML = ( { settings } ) => {
    return (
        <div className={settings && settings.classes ? settings.classes : ''} dangerouslySetInnerHTML={ {__html: settings.html} }/>
    )
}

export default SnippetHTML